module.exports = __webpack_public_path__ + "54e96c6ae3babb06086f2576ecfba905.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/down-30.png
// module id = 3122
// module chunks = 0